<form>

	<div class="form-group switch-custom-container pb-0 mb-0">
		<h2 data-testid="SUBSYS5_PINSITECARE_TITLE_TXT" class="text-uppercase mb-0">
			{{ labels().PIN_SITE_CARE_COMPONENT_TITLE }}
		</h2>
		<label for="toggle" class="switch ms-5">
			<input data-testid="SUBSYS5_PINSITECARE_TOGGLE" type="checkbox" [checked]="isEnabled()" (change)="toggle()">
			<span></span>
		</label>
	</div>

	@if (isEnabled()) {

	<div class="row mt-4">
		<div class="col-4">

			<div class="form-group pb-0">
				<label data-testid="SUBSYS5_PINSITECARE_FIRSTDAY_LBL" for="first-day">
					{{ labels().PIN_SITE_CARE_COMPONENT_FIRST_DAY }} &nbsp; *
				</label>
				<div class="col-10 col-lg-8 col-xl-6">
					<div class="input-group wrapper-calendar col-4 col-xl-12 p-0" #firstDayTarget>
						<i data-testid="SUBSYS5_PINSITECARE_FIRSTDAY_TOGGLE" class="material-icons input-group-append icon-calendar"
							(click)="firstDayPicker.toggle()" (keypress)="firstDayPicker.toggle()">today</i>
						<input data-testid="SUBSYS5_PINSITECARE_FIRSTDAY_INPUT" type="text" class="form-control text-white"
							id="first-day" [placeholder]="labels().PIN_SITE_CARE_COMPONENT_FIRST_DAY" [ngModel]="firstDayFormat()"
							[ngModelOptions]="{standalone: true}" readonly />
					</div>
				</div>
				@if (!firstDay()) {
				<div class="invalid-feedback d-block">{{ labels().PIN_SITE_CARE_COMPONENT_FIRST_DAY_REQUIRED }}</div>
				}
			</div>
			<datepicker data-testid="SUBSYS5_PINSITECARE_FIRSTDAY_DATEPICKER" #firstDayPicker [value]="firstDay()!"
				(dateChanged)="firstDay.set($event!)" [positionTarget]="firstDayTarget" placement="bottom-right" />

		</div>
		<div class="col-8">

			<div class="form-group pb-0">
				<label data-testid="SUBSYS5_PINSITECARE_FREQUENCY_LBL" for="frequency">
					{{ labels().PIN_SITE_CARE_COMPONENT_FREQUENCY }} &nbsp; *
				</label>
				<div role="group" class="btn-group wrapper-btn-days">
					@for (day of WEEKDAYS; track $index;) {
					<button data-testid="SUBSYS5_PINSITECARE_FREQUENCY_DAY_BTN" type="button" class="btn btn-secondary" [id]="day"
						[value]="frequency()?.[$index]" [class.selected]="frequency()?.[$index]" (click)="selectDay($index)">
						{{ labels()['PIN_SITE_CARE_COMPONENT_' + day] }}
					</button>
					}
				</div>
				<a data-testid="SUBSYS5_PINSITECARE_FREQUENCY_ALL_BTN" href="#" onclick="return false" class="d-block mb-2"
					style="width: fit-content;" (click)="selectAllDays()">
					{{ labels().PIN_SITE_CARE_COMPONENT_SELECT_ALL_BTN }}
				</a>
				@if (!frequency()?.includes(true)) {
				<div class="invalid-feedback d-block">{{ labels().PIN_SITE_CARE_COMPONENT_FREQUENCY_REQUIRED }}</div>
				}
			</div>

		</div>
	</div>

	}

</form>